var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9653 0.774414V14.1479H14.9626V2.78909L29.9653 0.774414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0127 16.8403H30.0153V30.2334L15.0127 28.2092V16.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0400391 14.1479V5.30424C-0.0400391 4.81293 -0.0400488 4.80351 0.450037 4.73472L12.2021 3.15234V14.1383L-0.0400391 14.1479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0300346 16.8403H12.2522V27.8263L7.4313 27.1776L0.330075 26.195C0.0900329 26.195 0 26.1064 0 25.851C0 22.9031 0 19.9552 0 17.0073C0.00772148 16.9512 0.0177606 16.8956 0.0300346 16.8403Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9853,
    height: 29.4789,
    fill: "white",
    transform: "translate(0 0.774414)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.5265eea5.svg";
export { ForwardRef as ReactComponent };